import { Component, ElementRef, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { RouteInfo } from '../_models/Portal/Menu';
import { PortalService } from '@app/_services/Portal/portal.services';
import { first } from 'rxjs/operators';
import { AccountService } from '@app/_services';
import { ResponseService, UserData } from '@app/_models';
import { BreakpointObserver } from '@angular/cdk/layout';
import swal from 'sweetalert2';
import { UsuariosServicesService } from '@app/_services/Usuarios/usuarios-services.service';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd} from '@angular/router';

import { filter } from 'rxjs/operators';

const misc: any = {
  navbar_menu_visible: 0,
  active_collapse: true,
  disabled_collapse_init: 0,
};
declare const $: any;

@Component({
    selector: 'app-sidebar-horizontal-cmp',
    templateUrl: 'sidebar-horizontal.component.html',
    styleUrls: ['./sidebar-horizontal.component.css'],
    standalone: false
})
export class SidebarHorizontalComponent implements OnInit {
  public menuItems: RouteInfo[];
  private dataUser: UserData;
  private sidebarVisible: boolean;
  private toggleButton: any;
  mobile_menu_visible: any = 0;
  public isAsociadoPre: boolean = false;
  public isAsociado: boolean = false;
  private _router: Subscription;
  private nativeElement: Node;
  ps: any;
  constructor(
    private breakpointObserver: BreakpointObserver,
    private portalService: PortalService,
    private accountService: AccountService,
    private _usuarioService: UsuariosServicesService,
    private element: ElementRef,
    private router: Router,
  ) {
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  toggle() {
    window.location.reload();
  }
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

 
  ngOnInit() {
    this.dataUser = this.accountService.userInfo;

      if (this.dataUser.Role === 'AsociadoPre') {
        this.isAsociadoPre = true;
      }
      if (this.dataUser.Role === 'Asociado') {
        this.isAsociado = true;
      }
      this.portalService
        .getMenuByRole(this.dataUser.Role)
        .pipe(first())
        .subscribe({
          next: (result) => {
            this.menuItems = result;
            localStorage.setItem('menuItems', JSON.stringify(result));
          },
          error: (error) => {
            console.log('error');
          },
        });
        const navbar: HTMLElement = this.element.nativeElement;
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('hide-sidebar');
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        if (body.classList.contains('sidebar-mini')) {
          misc.sidebar_mini_active = true;
        }
        if (body.classList.contains('hide-sidebar')) {
          misc.hide_sidebar_active = true;
        }
        this._router = this.router.events.pipe(
          filter((event) => event instanceof NavigationEnd))
          .subscribe((event: NavigationEnd) => {
            this.sidebarClose();
    
            const $layer = document.getElementsByClassName('close-layer')[0];
            if ($layer) {
              $layer.remove();
            }
          });

    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>(
        document.querySelector('.sidebar .sidebar-wrapper')
      );
      this.ps = new PerfectScrollbar(elemSidebar);
    }
  }

  updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      this.ps.update();
    }
  }
  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf('MAC') >= 0 ||
      navigator.platform.toUpperCase().indexOf('IPAD') >= 0
    ) {
      bool = true;
    }
    return bool;
  }

  sidebarToggle() {
    if (this.sidebarVisible === false) {

      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }

  sidebarOpen() {
    var $toggle = document.getElementsByClassName('navbar-toggler')[0];
    const toggleButton = this.toggleButton;
    const body = document.getElementsByTagName('body')[0];
    setTimeout(function () {
      toggleButton.classList.add('toggled');
    }, 500);
    body.classList.add('nav-open');
    setTimeout(function () {
      $toggle.classList.add('toggled');
    }, 430);

    var $layer = document.createElement('div');
    $layer.setAttribute('class', 'close-layer');

    if (body.querySelectorAll('.main-panel')) {
      document.getElementsByClassName('main-panel')[0].appendChild($layer);
    } else if (body.classList.contains('off-canvas-sidebar')) {
      document
        .getElementsByClassName('wrapper-full-page')[0]
        .appendChild($layer);
    }

    setTimeout(function () {
      $layer.classList.add('visible');
    }, 100);

    $layer.onclick = function () {
      //asign a function
      body.classList.remove('nav-open');
      this.mobile_menu_visible = 0;
      this.sidebarVisible = false;

      $layer.classList.remove('visible');
      setTimeout(function () {
        $layer.remove();
        $toggle.classList.remove('toggled');
      }, 400);
    }.bind(this);

    body.classList.add('nav-open');
    this.mobile_menu_visible = 1;
    this.sidebarVisible = true;
  }

  sidebarClose() {
    var $toggle = document.getElementsByClassName('navbar-toggler')[0];
    const body = document.getElementsByTagName('body')[0];
    this.toggleButton.classList.remove('toggled');
    var $layer = document.createElement('div');

    body.classList.remove('nav-open');
      this.mobile_menu_visible = 0;
      this.sidebarVisible = false;

      $layer.classList.remove('visible');
      setTimeout(function () {
        $layer.remove();
        $toggle.classList.remove('toggled');
      }, 400);
  }

  
  ValidChangePassword() {
    swal
      .fire({
        title: 'Cambio de Contraseña',
        html:
          '<br /><form method="post" id="taxcode-update" name="taxcodeUpdate">' +
          '<input   id="input-contrasena" autofocus  class="form-control wedding-input-text wizard-input-pad" type="password" name="taxCode" placeholder="Contraseña">' +
          '<input   id="input-contrasenaNueva" autofocus  class="form-control wedding-input-text wizard-input-pad" type="password"  placeholder="Contraseña Nueva" >  ' +
          '</form>',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })
      .then((result) => {
        const { isConfirmed } = result;
        if (isConfirmed) {
          if (
            $('#iinput-contrasena').val() === '' ||
            $('#input-contrasenaNueva').val() === ''
          ) {
            swal.fire({
              icon: 'warning',
              html: 'Es obligatorio ingresar los dos campos',
              customClass: {
                confirmButton: 'btn btn-success',
              },
              buttonsStyling: false,
            });
            return;
          }
          if (
            !this.testInputPasswordRegExp($('#input-contrasenaNueva').val())
          ) {
            swal.fire({
              icon: 'warning',
              html: `<div>
                <h4>Error de validacion, la contraseña debe contener:</h4>
                     <ol >
                     <li style="text-align: left;">Al menos una letra mayúscula</li>
                     <li style="text-align: left;">Al menos una letra minúscula</li>
                     <li style="text-align: left;">Al menos un dígito</li>
                    <li style="text-align: left;">Al menos un personaje especial</li>
                    <li style="text-align: left;">Mínimo ocho de longitud</li>
                     </ol></div>`,
              customClass: {
                confirmButton: 'btn btn-success',
              },
              buttonsStyling: false,
            });
            return;
          }
  
          this.CambiarContrasena(
            $('#input-contrasena').val(),
            $('#input-contrasenaNueva').val()
          );
        }
      });
  }

  public testInputPasswordRegExp(text): boolean {
    const reg = new RegExp(
      '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
    );
    const res = reg.test(text);
    return res;
  }
  CambiarContrasena(oldPassword, newPassword) {
    swal.fire('Procesando información');
    swal.showLoading();

    const objetoEnvio = {
      usuario: this.dataUser.RFC,
      contrasena: oldPassword,
      nuevaContrasena: newPassword,
    };
    console.log(objetoEnvio);
    this._usuarioService.CambioPassword(objetoEnvio).subscribe(
      (data: ResponseService) => {
        console.log('response', data);
        if (!data.hasError) {
          swal
            .fire({
              title: 'Contraseña Actualizada Correctamente',
              text: `El cambio se vera reflejado cuando ingreses nuevamente`,
              buttonsStyling: false,
              customClass: {
                confirmButton: 'btn btn-success',
              },
              icon: 'success',
            })
            .then((result) => {
              const { isConfirmed } = result;
              /*  this.goToBack(); */
            });
        } else {
          swal.fire({
            icon: 'error',
            title: '¡Error!',
            text: data.ErrorMsg,
            //footer: '<a href>Why do I have this issue?</a>'
          });
        }
      },
      (error) => {
        swal.fire({
          icon: 'error',
          title: '¡Error!',
          text: 'Ocurrio un error, vuelva a intentarlo nuevamente!',
          //footer: '<a href>Why do I have this issue?</a>'
        });
      }
    );
  }
}



